import React from 'react';
import { getSpreadDimensions } from '../../../BookDesign/constants';
import ElementRenderer from './ElementRenderer';
import { getPageNumber } from '../../../../utils/pageMapping';
import { jsPDF } from 'jspdf';

export default function PreviewSpread({ spread, book, scale = 1, debugMode, spreadNumber: spreadNumberProp }) {
  const dimensions = getSpreadDimensions(book?.pageSize || 'us-trade');
  const totalPages = parseInt(book?.totalPages || 0, 10);
  // Prefer explicitly provided spread number; fall back to spread.id if present
  const parsedFromId = parseInt(spread?.id?.replace('spread-', ''), 10);
  const spreadNumber = Number.isFinite(spreadNumberProp)
    ? spreadNumberProp
    : (Number.isFinite(parsedFromId) ? parsedFromId : 0);

  // Get the actual page numbers for this spread
  const leftPageNumber = getPageNumber(spreadNumber, false, totalPages);
  const rightPageNumber = getPageNumber(spreadNumber, true, totalPages);

  // Determine label visibility range (we no longer display 'Front/Back Cover' placeholders)
  const showLeftLabel = leftPageNumber > 0 && leftPageNumber <= totalPages;
  const showRightLabel = rightPageNumber > 0 && rightPageNumber <= totalPages;

  if (!spread?.elements) {
    return (
      <div
        className="relative"
        style={{
          width: dimensions.width * 2 * scale,
          height: dimensions.height * scale,
          margin: 0,
          padding: 0,
        }}
      >
        <div className="absolute inset-0 flex items-center justify-center text-gray-400">
          No content for this spread
        </div>
      </div>
    );
  }

  return (
    <div
      className="relative"
      style={{
        width: dimensions.width * 2 * scale,
        height: dimensions.height * scale,
        margin: 0,
        padding: 0,
      }}
    >
      {debugMode && (
        <div className="absolute top-2 right-2 z-[9999]">
          <button
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded text-sm"
            onClick={() => {
              const doc = new jsPDF();
              doc.text('This is the default font.', 20, 20);
              doc.setFont('helvetica', 'bold');
              doc.text('This is helvetica bold.', 20, 50);
              doc.save('font-test.pdf');
            }}
          >
            Font Test PDF
          </button>
        </div>
      )}
      {/* Elements */}
      {spread?.elements?.map((element) => (
        <ElementRenderer key={element.id} element={element} scale={scale} />
      ))}

      <div
        className="absolute inset-y-0 left-1/2 border-l border-dashed border-gray-300"
        style={{ transform: 'translateX(-0.5px)' }}
      />

      {/* Page numbers (respect book.hasPageNumbers, interior pages only) */}
      {book?.hasPageNumbers && (
        <>
          {showLeftLabel && (
            <div
              className="absolute bottom-1 text-gray-600 font-medium"
              style={{ left: '25%', transform: 'translateX(-50%)', pointerEvents: 'none', fontSize: '10px' }}
            >
              {leftPageNumber}
            </div>
          )}
          {showRightLabel && (
            <div
              className="absolute bottom-1 text-gray-600 font-medium"
              style={{ left: '75%', transform: 'translateX(-50%)', pointerEvents: 'none', fontSize: '10px' }}
            >
              {rightPageNumber}
            </div>
          )}
        </>
      )}
    </div>
  );
}
